// Lectura de roles desde el JWT emitido por el backend.
//
// El backend agrega cada rol como Claim(ClaimTypes.Role, rol) (ver
// UsuariosController.cs). En el payload decodificado eso aparece bajo la URI
// estándar de .NET; un solo rol llega como string y varios como array.

const ROLE_CLAIM = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role';

// Roles con visibilidad total sobre todas las vistas.
// - 'Administrador' y 'developer' actúan como administradores completos.
// - 'Consulta' ve todo pero en modo solo-lectura (la escritura la sigue
//   bloqueando isConsulta en el resto de la app).
export const SUPERUSER_ROLES = ['Administrador', 'developer', 'Consulta'];

// Decodifica el payload base64url de un JWT a objeto. Mismo enfoque (atob) que
// hooks/useTokenRenewal en floorapp — sin dependencias nuevas.
function decodePayload(jwt) {
    try {
        const payload = jwt && jwt.split('.')[1];
        if (!payload) return null;
        const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
        const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
        return JSON.parse(atob(padded));
    } catch {
        return null;
    }
}

// Devuelve SIEMPRE un array de strings de rol (vacío si el token no se puede
// leer o no trae el claim de rol).
export function getRolesFromToken(jwt) {
    const decoded = decodePayload(jwt);
    if (!decoded) return [];
    const claim = decoded[ROLE_CLAIM] ?? decoded.role ?? decoded.roles;
    if (Array.isArray(claim)) return claim.filter(Boolean);
    if (typeof claim === 'string') return [claim];
    return [];
}
